// @flow
import { Component } from '@angular/core';

@Component({
  selector: 'noauth',
  template: require('./noauth.html')
})
export class NoAuthComponent {
}
